import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["destroyField"]

  remove(event) {
    event.preventDefault()
    if (!confirm("Remove this item?")) return

    if (this.hasDestroyFieldTarget) {
      this.destroyFieldTarget.value = "1"
    }
    this.element.style.transition = "opacity 0.2s ease"
    this.element.style.opacity = "0"
    setTimeout(() => this.element.classList.add("d-none"), 200)
  }
}
